/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface RunEventContractGenerator$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runEventContractGeneratorRequest = createAction<PayloadData<void>>('EVENT_CONTRACT_GENERATOR_CONTROLLER__RUN_EVENT_CONTRACT_GENERATOR__REQUEST');
export const runEventContractGeneratorSuccess = createAction<PayloadData<void>>('EVENT_CONTRACT_GENERATOR_CONTROLLER__RUN_EVENT_CONTRACT_GENERATOR__SUCCESS');
export const runEventContractGeneratorFailure = createAction<PayloadData<Error, void, true>>('EVENT_CONTRACT_GENERATOR_CONTROLLER__RUN_EVENT_CONTRACT_GENERATOR__FAILURE');

export const runEventContractGeneratorActions = [
    runEventContractGeneratorRequest,
    runEventContractGeneratorSuccess,
    runEventContractGeneratorFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runEventContractGenerator = (config?: RunEventContractGenerator$Config) => {
    return {
        CALL_API: {
            types: runEventContractGeneratorActions,
            method: ApiMethods.POST,
            endpoint: `/event-contract-generator/run`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

